import GetMembershipOpenInvoicesRequestModelBase from '../_generated/modelBases/get-membership-open-invoices-request-model-base';

export default class GetMembershipOpenInvoicesRequestModel extends GetMembershipOpenInvoicesRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
